<kendo-card class="counter-card">
  <kendo-card-header>
    <h1 kendoCardTitle>
      <kendo-icon name="clip"></kendo-icon>
      Calibration Card<app-loader [status]="loaderStatus"></app-loader>
    </h1>
    <p kendoCardSubtitle>Device: {{ calibrationData.adc_name }}</p>
  </kendo-card-header>
  <kendo-card-body>

    <kendo-arcgauge
      [value]="GetValue()"
      [transitions]="true"
      [scale]="GetScale()"
      style="display:block;height:250px;"
    >
      <kendo-arcgauge-scale
        [majorTicks]="{ visible: true, color: '#008000'  }"
        [minorTicks]="{ visible: true, color: '#0000ff' }"
        [rangeSize]="10"
      >
        <kendo-arcgauge-scale-labels
          format="#.0"
          [color]="'#008000'"
          [visible]="true"
        >
        </kendo-arcgauge-scale-labels>
      </kendo-arcgauge-scale>

      <ng-template kendoArcGaugeCenterTemplate >
       <H2> {{ GetValue() }} {{ GetUnit() }} </H2>
      </ng-template>

    </kendo-arcgauge>
    <p>
      Channel : {{ calibrationData.adc_channel_SERCOM + 1 }}{{ calibrationData.adc_channel_SERCOM_is_A ? "A" : "*" }} <br/>
    </p>

    <app-trend [value] = "GetValue()"></app-trend>
  </kendo-card-body>
  <kendo-card-footer>
    <kendo-numerictextbox class="k-textbox medium"
                          [(value)]="uiChannel"
                          (blur)="UpdateChannel()"
                          format="n0"
                          [min]="1"
                          [max]="255"
    ></kendo-numerictextbox>


    <button kendoButton (click)="ToggleConversion()">{{ calibrationData.adc_conversion }}</button>
    <button kendoButton (click)="ToggleAChannel()">{{ (aChannel) ? "A" : "-" }}</button>

  </kendo-card-footer>
</kendo-card>

